<template>
  <el-tabs class="zr-details-tabs" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="项目概况" name="tab1">
      <p class="tab_title">项目概况</p>
      <el-form label-width="160px">
        <el-form-item label="项目名称">
          {{ data.name }}
        </el-form-item>
        <el-form-item label="业务类型">
          <span>{{ dealWayFullDisplay }}</span>
        </el-form-item>
        <el-form-item label="项目领域">
          {{ data.projectDomain }}
        </el-form-item>
        <el-form-item label="项目简介">
          <div v-html="data.projectBrief"></div>
        </el-form-item>

        <el-form-item label="标的信息">
          <div class="bdxx-table-wrap" v-if="bdxxList && bdxxList.length > 0">
            <table class="bdxx-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>知识产权类型</th>
                  <th>知识产权小类</th>
                  <th>业务类型</th>
                  <th>权证编号</th>
                  <th>权利人</th>
                  <th>发明(设计)人</th>
                  <th>交易份额（%）</th>
                  <th>共有情况</th>
                  <th>许可/质押等他项权利情况</th>
                  <th>其他信息</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in bdxxList" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.zscqlx || '' }}</td>
                  <td>{{ item.zscqxl || '' }}</td>
                  <td>{{ item.ywlx || '' }}</td>
                  <td>{{ item.qzbm || '' }}</td>
                  <td>{{ item.qlr || '' }}</td>
                  <td>{{ item.fmr || '' }}</td>
                  <td>{{ item.jyfe || '' }}</td>
                  <td>{{ item.gyqk || '' }}</td>
                  <td>{{ item.xkyzqt || '' }}</td>
                  <td>{{ item.qtxx || '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-form-item>

        <el-form-item label="专利数量" v-if="type != 1">
          <div class="flex-left flex-wrap">
            {{ zlsl }}

            <div style="margin-left: 20px">国内发明: {{ ipc.gnfm || 0 }}</div>

            <div style="margin-left: 20px">
              国内实用新型: {{ ipc.gnsyxx || 0 }}
            </div>

            <div style="margin-left: 20px">
              国内外观设计: {{ ipc.gnwgsj || 0 }}
            </div>

            <div style="margin-left: 20px">国外发明: {{ ipc.gwfm || 0 }}</div>

            <div style="margin-left: 20px">
              国外实用新型: {{ ipc.gwwgsj || 0 }}
            </div>

            <div style="margin-left: 20px">
              国外外观设计: {{ ipc.gwwgsj || 0 }}
            </div>

            <div style="margin-left: 20px">PCT: {{ ipc.pct || 0 }}</div>
          </div>
        </el-form-item>

        <el-form-item label="IP总数" v-if="type != 1">
          <div class="flex-left">
            {{ ipzs }}

            <div style="margin-left: 20px">专利数量: {{ zlsl }}</div>

            <div style="margin-left: 20px">商标: {{ ipc.sb || 0 }}</div>

            <div style="margin-left: 20px">版权: {{ ipc.bq || 0 }}</div>

            <div style="margin-left: 20px">布图设计: {{ ipc.btsj || 0 }}</div>

            <div style="margin-left: 20px">商业秘密: {{ ipc.jsmm || 0 }}</div>

            <div style="margin-left: 20px">其他: {{ ipc.qt || 0 }}</div>
          </div>
        </el-form-item>

        <el-form-item label="附件" v-if="type != 1">
          <div v-for="(item, index) in data.attachments" :key="index">
            <a :href="item.url" target="_blank">
              {{ item.name }}
            </a>
          </div>
        </el-form-item>

        <!-- 对外发布附件 -->
        <p class="tab_title" style="margin-top: 20px">
          附件信息
        </p>
        <el-form label-width="160px" class="info-form">
          <el-form-item label="发布附件">
            <div v-for="(url, index) in releaseAttachmentList" :key="index">
              <a :href="url" target="_blank">{{ url.split('/').pop() }}</a>
            </div>
          </el-form-item>
        </el-form>


      </el-form>
    </el-tab-pane>

    <el-tab-pane label="出让方概况" name="tab3">
      <template v-for="(crfInfo, idx) in transferorInfos">
        <p :key="'title-' + idx" v-if="transferorInfos.length > 1" class="tab_title" :style="idx > 0 ? 'margin-top: 24px' : ''">出让方 {{ idx + 1 }}</p>
        <el-form label-width="160px" class="applicant-form">
          <el-row :gutter="20">
            <template v-if="crfInfo && Object.keys(crfInfo).length">
              <!-- 通用字段 -->
              <el-col :span="12">
                <el-form-item label="国家/地区" v-if="crfInfo.gjdq">
                  {{ crfInfo.gjdq }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="主体类型" v-if="crfInfo.ztlx">
                  {{ crfInfo.ztlx }}
                </el-form-item>
              </el-col>
              <!-- 法人/企业：国有企事业单位、非国有企业 -->
              <template v-if="crfInfo.ztlx && crfInfo.ztlx !== '自然人'">
                <el-col :span="12">
                  <el-form-item label="单位名称" v-if="crfInfo.dwmc">
                    {{ crfInfo.dwmc }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="统一社会信用代码" v-if="crfInfo.tyshxydm">
                    {{ crfInfo.tyshxydm }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="法定代表人" v-if="crfInfo.fddbr">
                    {{ crfInfo.fddbr }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="注册资本" v-if="crfInfo.zczb">
                    {{ crfInfo.zczbcurrency || crfInfo.zczbCurrency || '人民币(CNY)' }} {{ crfInfo.zczb }} 万元
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="注册地址">
                    {{ getRegisteredAddress(crfInfo) || "-" }}
                  </el-form-item>
                </el-col>
              </template>
              <!-- 自然人 -->
              <template v-if="crfInfo.ztlx === '自然人'">
                <el-col :span="12">
                  <el-form-item label="姓 名" v-if="crfInfo.xm">
                    {{ crfInfo.xm }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="证件号码" v-if="crfInfo.zjhm">
                    {{ idNumChange(crfInfo.zjhm) }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="移动电话" v-if="crfInfo.yddh">
                    {{ idNumChange(crfInfo.yddh) }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="固定电话" v-if="crfInfo.gddh">
                    {{ idNumChange(crfInfo.gddh) }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="注册地址">
                    {{ getNaturalRegisteredAddress(crfInfo) || "-" }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="通讯地址" v-if="crfInfo.txdz || crfInfo.txxxdz">
                    {{ crfInfo.txdz }} {{ crfInfo.txxxdz }}
                  </el-form-item>
                </el-col>
              </template>
            </template>
          </el-row>
        </el-form>
      </template>
    </el-tab-pane>

    <el-tab-pane label="交易条件" name="tab4">
      <!-- 交易信息 -->
      <p class="tab_title" v-if="data.projType === 0 || data.projType === '0'">交易信息</p>
      <el-form
        v-if="data.projType === 0 || data.projType === '0'"
        label-width="160px"
        class="info-form"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="交易底价金额">
              <span v-if="hasAmountValue(data.floorPrice)">
                {{ formatCurrencyUnitLabel(data, 'floorPriceUnit') }} {{ data.floorPrice }} 万元
              </span>
              <span v-else>面议</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否优先受让" v-if="data.priorityTransferee">
              {{ data.priorityTransferee }}
            </el-form-item>
          </el-col>
          <el-col :span="8">

          </el-col>
        </el-row>

        <el-form-item label="补充交易条件" v-if="!isIntentProject">
          {{ data.additionCondition || '' }}
        </el-form-item>

      </el-form>

      

      <!-- 业务类型-转让表单 -->
      <p class="tab_title" v-if="data.dealWay && data.dealWay.indexOf('转让') !== -1">
        转让信息
      </p>
      <el-form
        v-if="data.dealWay && data.dealWay.indexOf('转让') !== -1"
        label-width="160px" class="info-form">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="转让底价金额" v-if="!shouldHideDealAmountFor('转让')">
              <span v-if="hasAmountValue(data.transferFloorPrice)">
                {{ formatCurrencyUnitLabel(data, 'transferFloorPriceUnit') }} {{ data.transferFloorPrice }} 万元
              </span>
              <span v-else>面议</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- <el-form-item label="知识产权转让份额合计">
              {{ data.totalTransferShare }}%
            </el-form-item> -->
          </el-col>
        </el-row>
        <el-form-item label="与转让相关的其他条件">
          {{ data.transferOtherConditions }}
        </el-form-item>
      </el-form>



      <!-- 业务类型-许可表单 -->
      <p class="tab_title" v-if="
        data.dealWay && data.dealWay.indexOf('许可') !== -1 && data.licenseType !== '开放许可'
      ">许可信息</p>

      <el-form v-if="
        data.dealWay && data.dealWay.indexOf('许可') !== -1 && data.licenseType !== '开放许可'
      " label-width="160px" class="info-form">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="许可底价金额" v-if="!shouldHideDealAmountFor('许可')">
              <span v-if="data.licenseFloorPrice !== '' && data.licenseFloorPrice !== null && data.licenseFloorPrice !== undefined">
                {{ formatCurrencyUnitLabel(data, 'licenseFloorPriceUnit') }} {{ data.licenseFloorPrice }} 万元
              </span>
              <span v-else>面议</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="知识产权许可类型">
              {{ data.licenseType }}
              <span v-if="data.licenseTypeCross">，交叉许可</span>
              <span v-if="data.licenseTypeFraction">，分许可</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item label="许可时间" v-if="data.projType === 0 || data.projType === '0'">
              {{ data.licenseDate }}
              <span v-if="data.licenseStart && data.licenseEnd">
                （{{ data.licenseStart | dateYMD }} 至 {{ data.licenseEnd | dateYMD }}）
              </span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="许可范围" v-if="data.licenseScope">
          {{ data.licenseScope }}
        </el-form-item>
        <el-form-item label="与许可相关的其他条件">
          {{ data.licenseOtherConditions || '' }}
        </el-form-item>
      </el-form>

      <!-- 开放许可业务表单 -->
      <p class="tab_title" style="margin-top: 20px" v-if="data.licenseType === '开放许可'">
        开放许可信息
      </p>
      <el-form v-if="data.licenseType === '开放许可'" label-width="160px" class="info-form">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="知识产权许可类型">
              {{ data.licenseType || "" }}
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="知识产权许可方式">
              {{
                Array.isArray(data.openLicenseMethod)
                  ? data.openLicenseMethod.join("、")
                  : (data.openLicenseMethod || "")
              }}
            </el-form-item>
          </el-col> -->
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="知识产权许可地域">
              {{ data.licenseScope || "" }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="许可时间" v-if="data.projType === 0 || data.projType === '0'">
              {{ data.licenseStart | dateYMD }} 至 {{ data.licenseEnd | dateYMD }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="!isIntentProject">
          <el-col :span="12">
            <el-form-item label="许可开始" v-if="data.licenseStart">
              {{ data.licenseStart | dateYMD }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="许可结束" v-if="data.licenseEnd">
              {{ data.licenseEnd | dateYMD }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="知识产权许可金额" v-if="!shouldHideDealAmountFor('许可')">
          <span v-if="hasAmountValue(data.licenseFloorPrice)">
            {{ formatCurrencyUnitLabel(data, 'licenseFloorPriceUnit') }} {{ data.licenseFloorPrice }} 万元
          </span>
          <span v-else>面议</span>
        </el-form-item>
        <el-form-item label="支付方式类型" v-if="data.licensePaymentType">
          {{ data.licensePaymentType }}
        </el-form-item>
        <el-form-item label="支付方式简述">
          {{ getLicensePaymentDesc(data) }}
        </el-form-item>
        <el-form-item label="与许可相关的其他条件">
          {{ data.licenseOtherConditions || '' }}
        </el-form-item>
        
      </el-form>

      <!-- 业务类型-作价入股表单 -->
      <p class="tab_title" style="margin-top: 20px"
        v-if="data.dealWay && data.dealWay.indexOf('作价入股') !== -1">
        作价入股
      </p>
      <el-form
        v-if="data.dealWay && data.dealWay.indexOf('作价入股') !== -1"
        label-width="160px" class="info-form">
        <el-form-item label="作价入股底价金额" v-if="!shouldHideDealAmountFor('作价入股')">
          <span v-if="hasAmountValue(data.stockFloorPrice) || hasAmountValue(data.stockPrice)">
            {{ formatCurrencyUnitLabel(data, 'stockFloorPriceUnit', 'stockPriceUnit') }} {{ hasAmountValue(data.stockFloorPrice) ? data.stockFloorPrice : data.stockPrice }} 万元
          </span>
          <span v-else>面议</span>
        </el-form-item>
        <el-form-item label="与作价入股相关的其他条件">
          {{ data.stockOtherConditions || '' }}
        </el-form-item>
      </el-form>      

      <!-- 交易价款信息 -->
      <p
        class="tab_title"
        style="margin-top: 20px"
        v-if="(data.projType === 0 || data.projType === '0') && (data.paymentType || data.paymentType2)"
      >
        交易价款信息
      </p>
      <el-form
        v-if="data.projType === 0 || data.projType === '0'"
        label-width="160px"
        class="info-form"
      >
        <el-form-item label="支付方式" v-if="data.paymentType || data.paymentType2">
          {{ data.paymentType }}
          <span v-show="data.paymentType && data.paymentType2">、</span>
          {{ data.paymentType2 }}
        </el-form-item>
        <el-form-item label="付款要求">
          {{ data.paymentDemand || '' }}
        </el-form-item>
        <el-form-item label="与交易相关的其他条件">
          <div v-html="nl2br(data.otherCondition)"></div>
        </el-form-item>
      </el-form>


    </el-tab-pane>

    <el-tab-pane v-if="type != 1" label="信息发布" name="tab5">
      <p class="tab_title">信息发布</p>

      <el-form label-width="160px">
        <el-form-item label="公告时间">
          <span v-show="data.announcementTime">自公告之日期{{ data.announcementTime }}个工作日</span>
        </el-form-item>
        <el-form-item label="挂牌期满">
          <!-- {{ data.listedTimeEnd }} -->
          <span v-show="data.listedTimeEnd == 1">更变公告内容，重新挂牌</span>
          <span v-show="data.listedTimeEnd == 2">延长信息发布，不变更挂牌条件，按照{{
            data.day1
          }}个工作日为一个周期，延长{{ data.delay1 }}个周期</span>
          <span v-show="data.listedTimeEnd == 3">延长信息发布，不变更挂牌条件，按照{{
            data.day2
          }}个工作日为一周期，直至征集到承租方</span>
          <span v-show="data.listedTimeEnd == 4">信息发布终结</span>
        </el-form-item>

        <el-form-item label="信息发布渠道">
          {{ data.accessInformation | accessInformationChange }}
        </el-form-item>

        <el-form-item label="发布期满后">
          <div>
            1、如征集到一家符合条件的意向受让方，在通过受让资格确认后，该意向受让方即为受让方应当以不低于交易底价受让标的；
          </div>
          <div>
            2、如征集到两家及以上符合条件的意向受让方，则采取以下方式确定最终受让方和受让价格。
          </div>
          {{ data.releaseTimeEnd }}
        </el-form-item>
      </el-form>
    </el-tab-pane>

    <el-tab-pane label="意向受让方资格" name="tab6">
      <p class="tab_title">意向受让资格</p>
      <el-form label-width="160px">
        <el-form-item label="受让方资格">
          <div>
            1、意向受让方应为依法设立并有效存续的境内外经济组织或具有完全民事行为能力的自然人；
          </div>
          <div>2、意向受让方应具有良好的财务状况和支付能力</div>
          <div>{{ data.assigneeQualification }}</div>
          <div>3、联合受让</div>
          <div>{{ data.theJoint }}</div>
          <div>
            4、意向受让方应具有良好的商业/个人信用，守法经营，诚实守信。近年来的经营活动中无不正当竞争手段取得经营权的记录；银行信用良好，无不良贷款记录；依法纳税、依法缴纳社会保障资金，无违反国家规定、损害合作方的不良记录。
          </div>
        </el-form-item>
      </el-form>
    </el-tab-pane>

    <el-tab-pane label="保证金" name="tab7">
      <p class="tab_title">保证金</p>
      <el-form label-width="160px">
        <el-form-item label="是否需要保证金">
          {{ data.isEarnestMoney }}
        </el-form-item>

        <div v-show="data.isEarnestMoney == '是'">
          <el-form-item label="交纳金额">
            <span v-if="hasAmountValue(data.earnestMoney)">
              {{ formatCurrencyUnitLabel(data, 'earnestMoneyUnit') }} {{ data.earnestMoney }}万元
            </span>
            <span v-else>面议</span>
          </el-form-item>

          <el-form-item label="交纳截止时间">
            {{ data.closingTime | dateYMD }}
          </el-form-item>

          <el-form-item label="交纳方式">
            {{
              data.payTheWay == "其他" ? data.payTheWayExtra : data.payTheWay
            }}
          </el-form-item>

          <el-form-item label="保证金事项">
            {{ data.marginMatters }}
          </el-form-item>
          <el-form-item label="保证金处理">
            {{ data.marginProcessing }}
          </el-form-item>
        </div>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { getRequest } from "../api/api";
import { formatCurrencyUnitLabel } from "../api/util";
export default {
  props: ["id", "type"],
  data() {
    return {
      activeName: "tab1",
      data: {},
      imgList: [],
      ipc: {},
      attachmentlist: []
    };
  },
  computed: {
    dealWayList() {
      if (!this.data || !this.data.dealWay) return [];
      const isFormalProject =
        this.data.projType === 0 || this.data.projType === "0";
      return [...new Set(String(this.data.dealWay).split(",").filter(Boolean))]
        .filter((item) => !(isFormalProject && item === "许可"));
    },
    dealWayListRaw() {
      if (!this.data || !this.data.dealWay) return [];
      return [...new Set(String(this.data.dealWay).split(",").filter(Boolean))];
    },
    dealWayDisplay() {
      return this.dealWayList.join("，");
    },
    dealWayDisplayItems() {
      const items = [...this.dealWayList];
      const hasLicenseDealWay = this.dealWayList.some(
        (item) => item.indexOf("许可") !== -1
      );
      if (this.data.licenseType || (this.data.permission && hasLicenseDealWay)) {
        items.push(this.data.licenseType || this.data.permission);
      }
      if (this.data.licenseTypeCross) items.push("交叉许可");
      if (this.data.licenseTypeFraction) items.push("分许可");
      if (this.dealWayList.includes("其他") && this.data.dealWayExtra) {
        items.push(this.data.dealWayExtra);
      }
      return items;
    },
    dealWayFullDisplay() {
      return this.dealWayDisplayItems.join("，");
    },
    transferorInfos() {
      if (!this.data || !this.data.crfInfos || !Array.isArray(this.data.crfInfos)) {
        return [];
      }
      return this.data.crfInfos.filter((i) => i.type == 1 || i.type === "1");
    },
    bdxxList() {
      if (!this.data || !this.data.bdxxs) {
        return [];
      }
      const list = typeof this.data.bdxxs === 'string' ? JSON.parse(this.data.bdxxs) : this.data.bdxxs;
      return Array.isArray(list) ? list : [];
    },
    reversedBdxxs() {
      return this.bdxxList.slice().reverse();
    },
    releaseAttachmentList() {
      if (!this.data || !this.data.uploadInfo || !this.data.uploadInfo.releaseAttachment) return [];
      const url = this.data.uploadInfo.releaseAttachment;
      return url.split(/[,，]/).map((s) => s.trim()).filter(Boolean);
    },
    isIntentProject() {
      if (!this.data || typeof this.data !== "object") return false;
      if (this.data.projType === 1 || this.data.projType === "1") return true;
      const accessInformation =
        this.data.accessInformation == null
          ? ""
          : String(this.data.accessInformation);
      if (
        accessInformation === "1" ||
        accessInformation === "公开挂牌-意向挂牌" ||
        accessInformation.indexOf("意向") !== -1
      ) {
        return true;
      }
      const announcementType =
        this.data.announcementType == null
          ? ""
          : String(this.data.announcementType);
      if (
        announcementType === "1" ||
        announcementType === "意向挂牌" ||
        announcementType === "公开挂牌-意向挂牌" ||
        announcementType.indexOf("意向") !== -1
      ) {
        return true;
      }
      return false;
    },
    zlsl() {
      let a1 = parseInt(this.ipc.gnfm) || 0;
      let a2 = parseInt(this.ipc.gnsyxx) || 0;
      let a3 = parseInt(this.ipc.gnwgsj) || 0;
      let a4 = parseInt(this.ipc.gwfm) || 0;
      let a5 = parseInt(this.ipc.gwsyxx) || 0;
      let a6 = parseInt(this.ipc.gwwgsj) || 0;

      console.log(a1, a2, a3, a4, a5, a6);
      console.log("国外实用新型", this.ipc.gwsyxx);

      return a1 + a2 + a3 + a4 + a5 + a6;
    },
    ipzs() {
      let zs = 0;
      for (var i in this.ipc) {
        zs += parseInt(this.ipc[i]) || 0;
      }
      zs -= parseInt(this.ipc.pct) || 0;
      zs -= parseInt(this.ipc.total1) || 0;
      zs -= parseInt(this.ipc.total2) || 0;
      return zs;
    },
  },
  filters: {
    accessInformationChange(value) {
      if (value == 1) {
        return "公开挂牌-意向挂牌";
      } else if (value == 2) {
        return "公开挂牌-正式挂牌";
      } else if (value == 3) {
        return "非公开挂牌";
      } else {
        return value;
      }
    },
  },
  methods: {
    hasAmountValue(value) {
      return value !== "" && value !== null && value !== undefined;
    },
    shouldHideDealAmountFor(dealType) {
      console.log('shouldHideDealAmountFor', this.dealWayListRaw);
      const isFormalProject = this.data.projType === 0 || this.data.projType === "0";
      if (!isFormalProject) return false;
      if (!Array.isArray(this.dealWayListRaw) || this.dealWayListRaw.length > 1) return false;
      // return this.dealWayList[0] === dealType;
      return true;
    },
    getRegisteredAddress(info) {
      if (!info || typeof info !== "object") return "";
      const composed = [info.zcdzsf, info.zcdzcs, info.zcdzxq, info.zcdzxx]
        .filter((v) => v != null && String(v).trim() !== "")
        .map((v) => String(v).trim())
        .join("");
      if (composed) return composed;
      return (
        info.zcdzxx ||
        info.registeredAddress ||
        info.zcdz ||
        info.domicile ||
        info.regAddress ||
        info.address ||
        ""
      );
    },
    getNaturalRegisteredAddress(info) {
      if (!info || typeof info !== "object") return "";
      return [info.zcdzsf, info.zcdzcs, info.zcdzxq]
        .filter((v) => v != null && String(v).trim() !== "")
        .map((v) => String(v).trim())
        .join("");
    },
    getLicensePaymentDesc(info) {
      if (!info || typeof info !== "object") return "";
      const value =
        info.licensePaymentDesc ||
        info.licensePaymentDescription ||
        info.licensePaymentBrief ||
        info.licensePaymentTypeDesc ||
        info.licensePaymentDemand ||
        "";
      return value == null ? "" : String(value);
    },
    formatCurrencyUnitLabel,
    nl2br(value) {
      if (value == null || value === "" || value === 0) return "";
      return String(value).replace(/\r?\n/g, "<br/>");
    },
    // 证件号码个人或多人中间屏蔽
    idNumChange(value) {
      let arr = value.split(/[,;|，、；]/)
      let a = []
      arr.forEach(item => {
        a.push(item.replace(/^(.{3})(?:\d+)(.{4})$/, "$1******$2"))
      });
      return a.join('、')
    },

    handleClick(tab, event) {
      console.log(tab, event);
    },
    getData(id) {
      getRequest({ url: `/api/v1/markRelease/getOne/${id}` }).then((res) => {
        if ((res.errcode = 200)) {
          this.data = res.data;

          if (res.data.imageUrl) this.imgList = JSON.parse(res.data.imageUrl);

          if (res.data.ipc) this.ipc = JSON.parse(res.data.ipc);

          if (res.data.attachment) this.attachmentlist = JSON.parse(res.data.attachment)

          if (res.data.bdxxs) {
            this.data.bdxxs = typeof res.data.bdxxs === 'string'
              ? JSON.parse(res.data.bdxxs)
              : res.data.bdxxs;
          }

          console.log(this.attachmentlist);
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
  },
  created() {
    this.getData(this.id);
  },
};
</script>

<style lang="scss">
.el-tabs__item {
  font-size: 16px;
}

.el-form-item__label {
  text-align: left;
}

.el-form {
  margin: 10px 0;
}

.el-form-item {
  margin-bottom: 5px;
}

.tab_title {
  font-size: 16px;
  font-weight: 500;
}

.tab_title.section-label {
  background: #ffeb3b;
  padding: 8px 12px;
  margin: 0 0 16px 0;
}

.info-form {
  margin: 0 0 20px 0;
}

.title {
  font-size: 24px;
  font-weight: bold;
  color: #1d2129;
  line-height: 32px;
  margin-bottom: 24px;
}

.bdxx-table-wrap {
  width: 100%;
  margin: 5px 0;
  overflow-x: auto;
  line-height: 14px;
}

.bdxx-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  th,
  td {
    border: 1px solid #000;
    padding: 8px 4px;
    text-align: center;
  }

  thead tr {
    background: #e8f3ff;
    color: #000;

    th {
      font-weight: normal;
    }
  }

  tbody tr {
    background: white;
    color: #000;
  }

  .col-right {
    text-align: right;
  }
}
</style>
